import watchAccountStatement from './accountStatement'

export default watchAccountStatement
